import { Resources } from 'constants/resources';

import { AxiosResponse, AxiosError } from 'axios';
import { axios } from 'config/axios';
import { DirectionValue } from 'types/embedded/direction';

export type OrderManualCreatePayload = {
  direction: DirectionValue;
  status: string;
  amount: string;
  createdAt: string;
  updatedAt: string;
  merchantReferenceId: string;
  providerReferenceId: string;
  customerId: string;
  customerAccount: string;
  merchantName: string;
  merchantAccountName: string;
  providerName: string;
  gatewayName: string;
  methodName: string;
  currency: string;
  country: string;
};

export const createOrderManual = async (data: OrderManualCreatePayload): Promise<AxiosResponse> => {
  return axios
    .post(Resources.OrderManualCreate, data)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};
